import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import withHooks from '../../../core/withHooks';
import { NavigationBar, mergeClassNames } from '@clockout-dev/design-elements';
import { NAVBAR_BRAND_SUBTITLE, NAVBAR_LOGO_SRC } from './navbar.constants';
import { NAVBAR_BRAND_PATH } from './navbar.paths';
import NewSidebarController from './newSidebar.controller';
import styles from './styles/newSidebar.module.scss';

class NewSidebar extends Inherit(NewSidebarController, Component) {
    render() {
        const user = this.props.user ?? this.data?.user;
        const fi = this.props.fi ?? user?.fi?.name;

        // Figma «Bank card»: Clockout mark + bank name + fixed product line.
        const brand = {
            logo: <img src={NAVBAR_LOGO_SRC} alt="Clockout" />,
            title: fi,
            subtitle: NAVBAR_BRAND_SUBTITLE,
            onClick: () => this.props.navigate(NAVBAR_BRAND_PATH),
        };

        const currentPath = this.resolveNavbarActivePath(this.props.location);
        const { classNames: classNamesProp, collapsible = true } = this.props;
        const classNames = {
            ...classNamesProp,
            root: mergeClassNames([collapsible && styles.root, classNamesProp?.root]),
            panel: mergeClassNames([collapsible && styles.panel, classNamesProp?.panel]),
        };

        return (
            <NavigationBar
                classNames={classNames}
                sections={this.getSections(user)}
                brand={brand}
                currentPath={currentPath}
                onNavigate={this.handleNavigate.bind(this)}
                collapsible={collapsible}
            />
        );
    }
}

export default withHooks(NewSidebar);
